import { render } from "./Boxtitle.vue?vue&type=template&id=165c8bf5"
const script = {}

import "./Boxtitle.vue?vue&type=style&index=0&id=165c8bf5&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__